// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*.flex-form-info {*/\n/*    padding: 5px;*/\n/*    display: flex;*/\n/*    justify-content: space-between;*/\n/*}*/\n/*.flex-form-footer {*/\n/*    padding: 5px;*/\n/*    display: flex;*/\n/*    justify-content: flex-end;*/\n/*    .flex-form-btn {*/\n/*        color: #3b7a53;*/\n/*        margin: 10px 10px 10px 0;*/\n/*        display: flex;*/\n/*        align-items: center;*/\n/*    }*/\n/*}*/\n/*.money-item {*/\n/*    color: #3b7a53;*/\n/*}*/\n", ""]);
// Exports
module.exports = exports;
